import { Add } from "@material-ui/icons";
import { useState } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { toast } from 'react-toastify';
import useCustomer from "../../../context/CustomerContext";
import { useDeleteDefaultRatecardMutation, useGetDefaultPricingRateCardListQuery } from "../../../features/cwtRateCard/cwtRateCardSlice";
import Spinner from "../../Spinner";
import Wrapper from "../../Wrapper";
import Contract from "./DefaultPricing/Contract";
import Dialog from "../../designSystem/Dialog";
import errorHandler from "../../hooks/ErrorHanlder";

const Admin = () => {
    const { addRateCardDefaultPricing, getDefaultCard, isLoading: isAdding } = useCustomer();
    const { data: rateCards } = useGetDefaultPricingRateCardListQuery();
    const combinations = { 1: 'Zone-CWT', 2: 'Region-CWT', 3: 'Zone-Pallet', 4: 'Region-Pallet' }
    const [selectedCard, setSelectedCard] = useState(0);
    const [deleteRateCard, { isLoading: isDeleting }] = useDeleteDefaultRatecardMutation();
    const [isOpen, setIsOpen] = useState(false);

    const deleteHandler = async () => {
        try {
            await deleteRateCard(selectedCard).unwrap();
            toast.success('Rate card deleted successfully', { position: 'top-center' });
            setIsOpen(false);
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } catch (error) {
            errorHandler(error);
        }
    }

    return (
        <>
            <Dialog title="Delete Rate Card" show={isOpen} onClose={() => setIsOpen(false)} description="Are you sure you want to Delete Rate Card" onSubmit={deleteHandler} isLoading={isDeleting} />
            <Wrapper>
                {isAdding ? <div><Spinner /></div> : null}
                <div className="default-pricing-title">
                    <h5>Default Pricing</h5>
                    <Row sm={3}>
                        <Form.Select aria-label="Default select example"
                            onChange={(e) => {
                                getDefaultCard(e.target.value)
                                setSelectedCard(e.target.value);
                            }}
                        >
                            <option value='0'>Choose a Default Rate Card</option>
                            {rateCards?.data && rateCards.data.map((rateCard) => (
                                <option value={rateCard.rateCardId}>{combinations[rateCard.rateCardId]}</option>
                            ))
                            }
                        </Form.Select>
                    </Row>
                    <div className="default-pricing-btn d-flex justify-content-end mb-2">
                        {selectedCard != "0" ?
                            <Button
                                disabled={isDeleting}
                                style={{ marginRight: '5px' }}
                                variant="danger"
                                onClick={() => setIsOpen(true)}
                            >
                                Delete
                            </Button> :
                            <Button
                                disabled={isAdding}
                                onClick={addRateCardDefaultPricing}
                            >
                                Add<Add />
                            </Button>
                        }
                    </div>
                </div>
                <div className="default-pricing">
                    <Contract selectedCard={selectedCard} />
                </div>
            </Wrapper>
        </>
    );
}
export default Admin;